import { DateTime } from 'luxon';

import ExternalSegment from '@/common/models/audience/ExternalSegment';
import Validatable from '@/validator/Validatable';

export default class LifesightAgeDemographic extends Validatable {
  private id: number;

  private name: string;

  private createdOnUtc: DateTime;

  private modifiedOnUtc: DateTime;

  private s3Path: string;

  private reach: number;

  constructor(
    id: number,
    name: string,
    createdOnUtc: DateTime,
    modifiedOnUtc: DateTime,
    s3Path: string,
    reach: number,
  ) {
    super();
    this.id = id;
    this.name = name;
    this.createdOnUtc = createdOnUtc;
    this.modifiedOnUtc = modifiedOnUtc;
    this.s3Path = s3Path;
    this.reach = reach;
  }

  get code(): string {
    if (this.name.includes('-')) {
      const range = this.name.split('-');
      return `E ${range[0]}-${range[1]}`;
    }
    return this.name;
  }

  static fromLifesightSegment(segment: ExternalSegment): LifesightAgeDemographic {
    return new LifesightAgeDemographic(
      segment.demographicId,
      segment.name,
      segment.createdOnUtc,
      segment.modifiedOnUtc,
      segment.s3Path,
      segment.reach,
    );
  }
}
